// extracted by css-extract-rspack-plugin
export default {"CtaButtons":"CtaButtons-module__CtaButtons__jYAAh","Button":"CtaButtons-module__Button__w8vMj"};